/**
 * find unsigned addendum if there is any
 * @param addendums note addendums
 */
export default function findUnsignedAddendum(addendums: ParsedNoteAddendum[]) {
  return addendums.reduce((prev, el) => {
    if (
      !el.sign_timestamp &&
      (!prev || prev.note_addendum_id < el.note_addendum_id)
    ) {
      return el;
    }
    return prev;
  }, undefined as typeof addendums[number] | undefined);
}
